import { useState } from 'react';

import { Divider } from '@hivebrite/design-system/Divider';

import { DEFAULT_SPACING_SIZE } from 'hb-builder/components/BuilderComponents/constants/spacingSize';
import ButtonsSpacing from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonsSpacing';
import { OPTIONS as NUMBER_BUTTONS_OPTIONS } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberButtons';
import StylingMode, {
  STYLING_MODE_DEFAULT_VALUE,
} from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode';
import CustomMode from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode';
import CustomModeCommonSettings from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomModeCommonSettings';
import NetworkMode from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/NetworkMode';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import {
  BUTTON_MODE_OPTIONS,
  type ButtonItemAttributes,
} from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';
import { type ButtonsItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonsItemAttributes';

const Style = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<ButtonItemAttributes | ButtonsItemAttributes>) => {
  const [stylingMode, setStylingMode] = useState(
    // The styling mode attribute is at the button level but common for both buttons.
    item.children?.[0]?.attributes?.mode || STYLING_MODE_DEFAULT_VALUE,
  );

  const settingProps = {
    defaultAttributes,
    item,
    onChange,
  };

  const numberButtons = item.children?.length || NUMBER_BUTTONS_OPTIONS.ONE;
  const isCustomMode = stylingMode === BUTTON_MODE_OPTIONS.CUSTOM;

  return (
    <>
      <StylingMode
        {...settingProps}
        defaultValue={stylingMode}
        setStylingMode={setStylingMode}
      />
      {isCustomMode && numberButtons > 1 && (
        <>
          <ButtonsSpacing
            {...settingProps}
            defaultValue={
              item.attributes?.childrenSpacing || DEFAULT_SPACING_SIZE
            }
          />
          <CustomModeCommonSettings item={item} settingProps={settingProps} />
        </>
      )}
      <Divider mb={5} mt={2} />
      {stylingMode === BUTTON_MODE_OPTIONS.NETWORK && (
        <NetworkMode item={item} settingProps={settingProps} />
      )}
      {isCustomMode && <CustomMode item={item} settingProps={settingProps} />}
    </>
  );
};

export default Style;
